import { StylovyzeIconProps } from '@innovyze/stylovyze';
import { Path } from '@innovyze/stylovyze';
import React from 'react';

const RiskIcon: React.FC<StylovyzeIconProps> = ({
	color,
	...props
}: StylovyzeIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="21"
			height="22"
			fill="none"
			viewBox="0 0 21 22"
			{...props}
		>
			<Path
				color={color}
				fill={color}
				d="M10.983 15.604l5.71-6.458-6.457 5.71a.996.996 0 00-.932 1.68 1 1 0 001.679-.932zM17.296 9.806l-1.05 1.187a7.846 7.846 0 011.66 4.83h1.555a9.405 9.405 0 00-2.165-6.017z"
			/>
			<Path
				color={color}
				fill={color}
				fillRule="evenodd"
				d="M11.098 8.008c1.4.193 2.682.756 3.749 1.584l1.186-1.05a9.405 9.405 0 00-5.916-2.163l.98 1.629zM5.17 9.6h-2.26a9.408 9.408 0 00-2.339 6.222h1.556A7.88 7.88 0 015.17 9.6z"
				clipRule="evenodd"
			/>
			<Path
				color={color}
				fill={color}
				d="M5.516 6.35h-.849v.849h.85v-.85zM5.516 3.377h-.849v2.548h.85V3.377z"
			/>
			<Path
				color={color}
				fill={color}
				d="M10.093 8.627H.131L5.112 0l4.981 8.627zm-8.491-.849h7.02l-3.51-6.08-3.51 6.08z"
			/>
		</svg>
	);
}

export default RiskIcon;
